import http, { API_CORE } from '../http';

export default function ProductEditService() {
  const editProduct = async (productIdOrSlug, input) => {
    const response = await http(API_CORE).patch(`/edit-product/${productIdOrSlug}`, input);

    return response.data;
  };

  const editProductDetail = async (productIdOrSlug, productDetailId, input) => {
    const response = await http(API_CORE).patch(
      `/edit-product/${productIdOrSlug}/product-detail/${productDetailId}`,
      input
    );

    return response.data;
  };

  const updateProductDetailImageOrdering = async (productIdOrSlug, productDetailId, input) => {
    const response = await http(API_CORE).patch(
      `/edit-product/${productIdOrSlug}/product-detail/${productDetailId}/images`,
      input
    );

    return response.data;
  };

  return {
    editProduct: editProduct,
    editProductDetail: editProductDetail,
    updateProductDetailImageOrdering: updateProductDetailImageOrdering,
  };
}
